<template>
  <div class="p-3">
      <div
        class="mc-widget-call__main-container"
        :class="{ collapsed: isCollapsed }"
        :style="{ 'max-height': isCollapsed ? '0px' : '190px' }"
      >
        <!-- WebviewCallCard for enhanced UI -->
        <WebviewCallCard
          :vehicle="vehicle"
          :callState="calls[vehicle?.vehicle_id]?.state"
          :is-collapsed="isCollapsed"
          @handleToggleMic="clickToggleMuted"
          @handleEndCall="clickEndCall"
        />
        
        <!-- Hidden CallItem for actual VOIP functionality -->
        <CallItem
          v-for="vehicleId in Object.keys(calls)"
          :ref="`voip-${vehicleId}`"
          :key="vehicleId"
          :licensePlate="calls[vehicleId].licensePlate"
          :driver="calls[vehicleId].driver"
          :callState="calls[vehicleId].state"
          :vehicleId="Number(vehicleId)"
          :imei="calls[vehicleId].imei"
          :token="calls[vehicleId].token"
          :deviceType="calls[vehicleId].deviceType"
          :muted="calls[vehicleId].isMuted"
          :entryPoint="calls[vehicleId].entryPoint"
          :audioContext="audioContext"
          @setCallsValue="setCallsValue"
          style="display: none;"
        />
      </div>
      <EndCall
        v-if="sumCallsActive > 0"
        @clickEndCall="clickEndCall"
        @clickToggleMuted="clickToggleMuted"
        style="display: none;"
      />
  </div>
</template>

<script>
import EndCall from '../CallItemState/EndCall.vue'
import CallItem from '../CallItem.vue'
import WebviewCallCard from './WebviewCallCard.vue'
import { Helper } from '@/mixin/helper'
import KJUR from 'jsrsasign'
import { mapGetters } from 'vuex'
import * as vehicles from '@/services/rest-api-sms/lib/vehicle/vehicle'

export default {
  components: {
    EndCall,
    CallItem,
    WebviewCallCard,
  },
  
  mixins: [Helper],
  data() {
    return {
      calls: {},
      isDrag: false,
      isGrabbing: false,
      audioContext: null,
      vehicle: null,
    }
  },
  computed: {
    ...mapGetters('voip', ['sumCallsActive', 'vehicleIdsCallActive']),
    isCollapsed() {
      return this.$store.state.voip.isCollapsed
    },
  },

  mounted() {
    this.getDeviceByParams()
  },
  
  watch: {
    sumCallsActive(val) {
      if (val === 0) {
        this.audioContext.close()
      } else {
        this.audioContext = new AudioContext()
        this.$store.commit('voip/setIsMuted', false)
      }
    },
    async '$store.state.voip.calls'(calls, oldCalls) {
      this.delay(500)
      const vehicleIds = calls.map((call) => call.vehicleId)
      const isRemoved = oldCalls.length > calls.length
      if (isRemoved) {
        const vehicleIdRemoved = oldCalls
          .map((call) => call.vehicleId)
          .find((oldVehicleId) => !calls.some((call) => call.vehicleId === oldVehicleId))
        delete this.calls[vehicleIdRemoved]
      }
      for (let i = 0; i < vehicleIds.length; i++) {
        const _data = calls[i]
        const isNewCall = !oldCalls.map((call) => call.vehicleId).includes(_data.vehicleId)
        if (isNewCall) {
          const imei = _data.imei
          const header = { alg: 'HS256', typ: 'JWT' }
          const payload = { client_id: 'frontend_' + imei }
          const secret = process.env.VUE_APP_VOIP_JWT_SECRET
          const token = KJUR.jws.JWS.sign(header.alg, header, payload, secret)
          this.calls[vehicleIds[i]] = {
            ..._data,
            isMuted: false,
            state: 'connecting',
            token,
          }

          this.$store.commit('video/setVoipState', {
            vehicleId: vehicleIds[i],
            values: { state: 'connecting' },
          })
        }
        if (!isNewCall && calls.length > 1) {
          this.calls[vehicleIds[i]].isMuted = true
        }
      }

      this.$forceUpdate()
    },
  },

  methods: {
    setCallsValue(vehicleId, key, value) {
      this.calls[vehicleId][key] = value
      this.$forceUpdate()
    },
    clickEndCall() {
      const vehicleIds = Object.keys(this.calls)
      for (let i = 0; i < vehicleIds.length; i++) {
        const vehicleId = vehicleIds[i]
        const voipComponent = this.$refs[`voip-${vehicleId}`][0]
        voipComponent.stopCall()
      }
      this.$store.commit('video/resetVoipVehicleIdActive')
      this.$store.commit('video/resetVoipState')
    },
    clickToggleMuted() {
      const isMuted = this.$store.state.voip.isMuted
      const vehicleIds = Object.keys(this.calls)
      for (let i = 0; i < vehicleIds.length; i++) {
        const vehicleId = vehicleIds[i]
        const voipComponent = this.$refs[`voip-${vehicleId}`][0]
        voipComponent.toggleMuteMic(isMuted)
      }
    },
    async getDeviceByParams() {
      let payload = {
        filters: [`vehicle_id eq ${this.$route.params.id ?? ''}`, 'device_category'],
        page: 1,
        limit: 1,
      }

      const vehicleList = await vehicles.get(payload, this.selectedServerRegion)

      if (!vehicleList?.data) {
        this.filteredItems = []
        this.totalRows = 0
        this.currentPage = 1
        this.perPage = 10
        this.totalPages = 1
        this.devices = []
        this.loading = false
        return
      }

      const vehicle = vehicleList.data.paginated_result;
      if (vehicle.length > 0) {
        this.vehicle = vehicle[0]
      }
    },
  },
}
</script>
